module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('label', {
    attrs: {
      "for": "id_test"
    }
  }, [_vm._v("Send Test emails to yourself?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.smtp.test),
      expression: "smtp.test"
    }],
    attrs: {
      "type": "checkbox",
      "id": "id_test"
    },
    domProps: {
      "checked": Array.isArray(_vm.smtp.test) ? _vm._i(_vm.smtp.test, null) > -1 : (_vm.smtp.test)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.smtp.test,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.smtp.test = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.smtp.test = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.smtp.test = $$c
        }
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "value": "send"
    },
    on: {
      "click": function($event) {
        _vm.send()
      }
    }
  }, [(_vm.sending) ? _c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }) : _vm._e(), _vm._v(" "), (_vm.smtp.test) ? _c('span', [_vm._v("Send Test")]) : _c('span', [_vm._v("Send to recipients")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cddf8dc0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SmtpInfo.vue
// module id = 85
// module chunks = 2